// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Header
*/

.header {
  transition: all 0.5s;
  z-index: 997;
  height: 60px;
  box-shadow: 0px 2px 20px rgba(1, 41, 112, 0.1);
  background-color: #fff;
  padding-left: 20px;
}

/* Search Bar */
/* Toggle Sidebar Button */
.header .toggle-sidebar-btn {
  font-size: 32px;
  padding-left: 10px;
  cursor: pointer;
  color: #012970;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/header.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,8CAA8C;EAC9C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,eAAe;AACf,0BAA0B;AAC1B;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/**\nHeader\n*/\n\n.header {\n  transition: all 0.5s;\n  z-index: 997;\n  height: 60px;\n  box-shadow: 0px 2px 20px rgba(1, 41, 112, 0.1);\n  background-color: #fff;\n  padding-left: 20px;\n}\n\n/* Search Bar */\n/* Toggle Sidebar Button */\n.header .toggle-sidebar-btn {\n  font-size: 32px;\n  padding-left: 10px;\n  cursor: pointer;\n  color: #012970;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
